export const selectRolePermissions = (state) =>
  state.roleAccess?.rolePermissions || [];

export const selectRolePermissionsLoading = (state) =>
  state.roleAccess?.loading || false;

export const selectRolePermissionsError = (state) =>
  state.roleAccess?.error || null;

export const selectAssignRolePermissionsLoading = (state) =>
  state.roleAccess?.assignLoading || false;

export const selectSelectedRolePermissions = (state) =>
  state.roleAccess?.selectedRolePermissions || null;
